export const CDN_BASE_URL = 'https://cdn.morpho.org'

/**
 * Constructs a full CDN URL from a relative path.
 * @param path - Relative path (defaults to "/")
 * @returns Full CDN URL string
 */
export const getCdnUrl = (path = '/') => new URL(path, CDN_BASE_URL).toString()

export const TOU_URL = 'https://morpho.org/terms-of-use/'

export const MORPHO_TOKEN_FAQ_URL =
  'https://docs.morpho.org/governance/morpho-token/morpho-token-faq'

export const FALLBACK_APP_URL = 'https://fallback.morpho.org'

export const MERKL_API_BASE_URL = 'https://api.merkl.xyz'

export const MERKL_DASHBOARD_URL = 'https://app.merkl.xyz/users'

export const MERKL_OPPORTUNITIES_URL = 'https://app.merkl.xyz/opportunities'
